// Static import of place type data to avoid circular dependency issues
const placeTypeMap = {
    'Q515': '🏙️',   // city
    'Q1549591': '🌆', // big city
    'Q3957': '🏘️',   // town
    'Q3558970': '🏘️', // small town
    'Q532': '🏡',     // village
    'Q5084': '🏠',    // hamlet
    'Q123705': '🏘️', // neighborhood
    'Q188509': '🏡', // suburb
    'Q875157': '🏖️', // resort
    'Q15284': '🏛️',  // municipality
    'Q484170': '🏛️', // commune
    'Q149621': '📋', // district
    'Q28575': '📍',  // county
    'Q34876': '🗺️',  // province
    'Q82794': '🌍',  // region
    'Q23397': '🏞️',  // lake
    'Q4022': '🏞️',   // river
    'Q47521': '💧',   // stream
    'Q1397220': '🪩', // pond
    'Q131681': '🏞️', // reservoir
    'Q34038': '💦',   // waterfall
    'Q124714': '💧', // spring
    'Q39594': '🌊',   // bay
    'Q44783': '🌊',   // gulf
    'Q8473': '🌊',    // strait
    'Q8502': '⛰️',    // mountain
    'Q46831': '🏔️',   // mountain range
    'Q207326': '🗻',  // peak
    'Q54050': '⛰️',   // hill
    'Q75520': '🏔️',   // plateau
    'Q1244695': '⛰️', // ridge
    'Q39816': '🏞️',  // valley
    'Q6746': '🏔️',    // canyon
    'Q156537': '🏔️', // gorge
    'Q133056': '🚶', // pass
    'Q4421': '🌲',    // forest/wood
    'Q2958444': '🌳', // grove
    'Q1006733': '🌾', // meadow
    'Q2735': '🌾',    // prairie
    'Q30198': '🌿',   // marsh
    'Q166735': '🌿',  // swamp
    'Q3770': '🏖️',    // cape
    'Q34763': '🌊',   // peninsula
    'Q23442': '🏝️',   // island
    'Q33837': '🏝️',   // archipelago
    'Q40080': '🏖️',   // beach
    'Q107425': '🏔️', // cliff
    'Q83261': '🏜️',   // dune
    'Q8514': '🏜️',    // desert
    'Q43387': '🌴',   // oasis
    'Q35666': '🧊',   // glacier
    'Q1327063': '❄️', // icefield
    'Q23413': '🏰',   // castle
    'Q744099': '🏛️', // ruins
    'Q4989906': '🗿', // monument
    'Q839954': '🏺', // archaeological site
    'Q12280': '🌉',   // bridge
    'Q44377': '🕳️',   // tunnel
    'Q44782': '⚓',   // port
    'Q1248784': '✈️' // airport
};

class Place {
    constructor(wikidataID, wikidataLabel, lat, long, matchedType = null, matchedTypeLabel = null, existingLabel = null) {
        this.wikidataID = wikidataID; // wikidata node
        this.wikidataLabel = wikidataLabel;
        this.lat = lat; // coordinates
        this.lon = long; // coordinates
        this.matchedType = matchedType; // The Wikidata Q-ID that matched the search
        this.matchedTypeLabel = matchedTypeLabel; // Human readable label for the matched type
        this.existingLabel = existingLabel; // Existing label in the selected language (if any)
    }
    
    // Get the emoji icon for this place based on its matched type
    getTypeIcon() {
        if (!this.matchedType) return '📍'; // Default pin icon
        
        // Extract just the Q-ID from the full Wikidata URL if needed
        const qId = this.matchedType.includes('entity/') 
            ? this.matchedType.replace('http://www.wikidata.org/entity/', '')
            : this.matchedType;
        
        // Return the emoji from our static map
        return placeTypeMap[qId] || '📍';
    }
    
    // Get the display name for the matched type
    getTypeDisplayName() {
        return this.matchedTypeLabel || 'Unknown Place';
    }
    
    // Check if this place only has a Q-ID as its name (no proper label)
    isUnnamedPlace() {
        return !this.wikidataLabel || this.wikidataLabel.trim() === '' || this.wikidataLabel.startsWith('Q');
    }
    
    // Check if this place has an existing label in the selected language
    hasExistingLabel() {
        return this.existingLabel && this.existingLabel.trim() !== '';
    }
    
    // Get a user-friendly name, with fallback for unnamed places
    getDisplayName() {
        if (this.isUnnamedPlace()) {
            const qId = this.wikidataID.includes('entity/') 
                ? this.wikidataID.replace('http://www.wikidata.org/entity/', '')
                : this.wikidataID;
            return `Unnamed Place (${qId})`;
        }
        return this.wikidataLabel || 'Unknown Place';
    }
}

export default Place;